import ManageUserEditContainer from './ManageUserEditContainer';

export default ManageUserEditContainer;
